var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mt-6",attrs:{"color":"primary","dense":"","outlined":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }